import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaWellApi = createApi({
    reducerPath: "core/measurement/well",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementWellList"],
    endpoints: (builder) =>({
        measurementWellFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementWellList'],
            query: (query = '') => ({
                url: "core/measurement/well" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementWellCreate: builder.mutation({
            invalidatesTags: ['measurementWellList'],
            query: (data)=>({url: "core/measurement/well", method: "POST", data})
        }),
        measurementWellUpdate: builder.mutation({
            invalidatesTags: ['measurementWellList'],
            query: (data)=>({url: "/core/measurement/well/"+data.id, method: "PUT", data})
        }),
        measurementWellDelete: builder.mutation({
            invalidatesTags: ['measurementWellList'],
            query: (id)=>({url: "/core/measurement/well/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementWellFindAllQuery, useMeasurementWellCreateMutation, useMeasurementWellUpdateMutation, useMeasurementWellDeleteMutation } = meaWellApi;
export {meaWellApi};
